import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface, Empty_Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { DataEntity_Detail_04_Interface, Empty_DataEntity_Detail_04_Interface } from 'src/app/Interface/DataEntity/04/DataEntity_Detail_04_Interface';
import { DataEntity_Main_04_Interface, Empty_DataEntity_Main_04_Interface } from 'src/app/Interface/DataEntity/04/DataEntity_Main_04_Interface';
import { DataEntity_Resolution_04_Interface, Empty_DataEntity_Resolution_04_Interface } from 'src/app/Interface/DataEntity/04/DataEntity_Resolution_04_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Unit_Interface } from 'src/app/Interface/Unit_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { DataEntity04Service } from 'src/app/Service/DataEntity/04/DataEntity04.service';
import { DataEntityMainService } from 'src/app/Service/DataEntity/DataEntityMain.service';
import { UnitService } from 'src/app/Service/Unit/Unit.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-DataEntity04',
  templateUrl: './DataEntity04.component.html',
  styleUrls: ['./DataEntity04.component.css']
})
export class DataEntity04Component implements OnInit {

  constructor(
    private Calibration_Service: CalibrationService,
    private DataEntity04_Service: DataEntity04Service,
    private DataEntityMain_Service: DataEntityMainService,
    private Alerify_Service: AlertifyService,
    private Unit_Service: UnitService,
    private modalService: BsModalService,
    private route: ActivatedRoute
  ) { }

  Token: String = '';
  FileName: Array<General_Interface> = []
  FolderName: string = '';
  form_type: number = 0

  CertificateCode: String = '';
  CertificateUrlPdf: string = ''

  Manufacture_txt: String = '';
  Type_txt: String = '';
  Model_txt: String = '';

  DataEntity_Id: number = 7;


  InProccessing: boolean = false;
  Calibration_Device_Id: number = 0;
  Calibration_Id: number = 0;
  Observation: number = 0;


  unit_nomimal: string = ''
  unit_reference: string = ''
  unit_correction: string = ''
  unit_correction_eqution: string = ''
  unit_uncertainy: string = ''
  unit_working: string = ''
  unit_zfactor: string = ''

  range_nominal: string = ''
  range_nominal_unit: string = ''

  capability: string = ''

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.MainFormDataEntity = new FormGroup({
      id: new FormControl(),

      Temperature_Air_before: new FormControl(null, [Validators.required]),
      Temperature_Air_after: new FormControl(null, [Validators.required]),

      Humidity_Air_before: new FormControl(null, [Validators.required]),
      Humidity_Air_after: new FormControl(null, [Validators.required]),

      Pressure_before: new FormControl(null, [Validators.required]),
      Pressure_after: new FormControl(null, [Validators.required]),
    });

    this.ResolutionFormDataEntity = new FormGroup({
      range_max: new FormControl(null, [Validators.required]),
      range_min: new FormControl(null, [Validators.required]),
      scale: new FormControl(null, [Validators.required]),
    });

    this.ResolutionFormDataEntity = new FormGroup({
      range_max: new FormControl(null, [Validators.required]),
      range_min: new FormControl(null, [Validators.required]),
      unit: new FormControl("", [Validators.required]),
    });

    this.Calibration_Device_Id = Number(this.route.snapshot.paramMap.get('id'));
    this.OnIntial();
  }

  OnIntial() {
    this.DataEntity04_Service.GetSingle(this.Token, this.Calibration_Device_Id, this.DataEntity_Id).subscribe(
      (data) => {
        if (data['result'] != null) {
          var temp: DataEntity_Main_04_Interface = Empty_DataEntity_Main_04_Interface();
          this.Observation = data['observation'];

          this.capability = temp.capability;

          this.Nominal_Value_List_g = []
          this.Nominal_Value_List_kg = []
          this.Nominal_Value_List_mg = []

          this.FileName = data['file']
          this.DataList_Resolution = data['resolution'];
          temp = data['result']
          this.Calibration_Id = temp.id
          this.FolderName = temp.pdf_src

          this.range_nominal = temp.range_nominal
          this.range_nominal_unit = temp.range_nominal_unit


          this.Manufacture_txt = temp.manufacture;
          this.Type_txt = temp.type;
          this.Model_txt = temp.model;

          if (data['certificateUrl'])
            this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
          else
            this.CertificateUrlPdf = ""



          this.get_Form_Temperature_Air_before().setValue(temp['temperature_Air_before']);
          this.get_Form_Temperature_Air_after().setValue(temp['temperature_Air_after']);

          this.get_Form_Humidity_Air_before().setValue(temp['humidity_Air_before']);
          this.get_Form_Humidity_Air_after().setValue(temp['humidity_Air_after']);

          this.get_Form_Pressure_before().setValue(temp['pressure_before']);
          this.get_Form_Pressure_after().setValue(temp['pressure_after']);

          for (let item of data['detail']) {

            var tempDetail: DataEntity_Detail_04_Interface = Empty_DataEntity_Detail_04_Interface();

            tempDetail.marking = item['marking'];
            tempDetail.nominal = item['nominal'];
            tempDetail.uncertainty = item['uncertainty'];
            tempDetail.found = item['found'];
            tempDetail.left = item['left'];
            tempDetail.converage = item['converage'];
            tempDetail.uncertainty = item['uncertainty'];
            tempDetail.before = item['before'];
            tempDetail.status = item['status'];

            if (tempDetail.status == 1)
              this.Nominal_Value_List_mg.push(tempDetail);
            else if (tempDetail.status == 2)
              this.Nominal_Value_List_g.push(tempDetail);
            else
              this.Nominal_Value_List_kg.push(tempDetail);

          }

        }

        this.Read_Unit()
        this.CertificateCode = data['certificate_Code'];
        this.form_type = data['form_type'];
      },
      (error) => {
        localStorage.clear()
        location.reload();
      }
    );
  }

  //#region Main Data Entity
  Nominal_Value_List: Array<DataEntity_Detail_04_Interface> = [];
  Nominal_Value_List_mg: Array<DataEntity_Detail_04_Interface> = [];
  Nominal_Value_List_g: Array<DataEntity_Detail_04_Interface> = [];
  Nominal_Value_List_kg: Array<DataEntity_Detail_04_Interface> = [];
  MainFormDataEntity: FormGroup;

  get_Form_Temperature_Air_before() {
    return this.MainFormDataEntity.get('Temperature_Air_before') as FormControl;
  }
  get_Form_Temperature_Air_after() {
    return this.MainFormDataEntity.get('Temperature_Air_after') as FormControl;
  }

  get_Form_Humidity_Air_before() {
    return this.MainFormDataEntity.get('Humidity_Air_before') as FormControl;
  }
  get_Form_Humidity_Air_after() {
    return this.MainFormDataEntity.get('Humidity_Air_after') as FormControl;
  }

  get_Form_Pressure_before() {
    return this.MainFormDataEntity.get('Pressure_before') as FormControl;
  }
  get_Form_Pressure_after() {
    return this.MainFormDataEntity.get('Pressure_after') as FormControl;
  }


  //#endregion

  //#region Upload

  Procssing_Import: boolean = false
  upload_file_excel(files, status: number) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import = true

    this.DataEntity04_Service.uploadFile(formData, this.Token).subscribe(
      data => {
        this.Procssing_Import = false
        if (data['dsc']) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else {
          //this.Nominal_Value_List=[]
          this.Alerify_Service.SuccessMessage("The information was loaded successfully.")

          for (let item of data['filename']) {
            var temp1: General_Interface = Empty_General_Interface()
            temp1.id = 0
            temp1.title = item
            this.FileName.push(temp1)
          }

          this.capability = data['capability']

          for (let item of data['nominal']) {
            var temp: DataEntity_Detail_04_Interface = Empty_DataEntity_Detail_04_Interface()

            temp.uncertainty = item['uncertainty']
            temp.nominal = item['nominal']
            temp.found = item['conventional']
            temp.uncertainty = item['uncertainty']
            temp.converage = item['coverage']
            temp.before = false
            temp.status = status

            if (status == 1)
              this.Nominal_Value_List_mg.push(temp)
            else if (status == 2)
              this.Nominal_Value_List_g.push(temp)
            else
              this.Nominal_Value_List_kg.push(temp)

          }

        }
      }
    )

  }

  Procssing_Import2: boolean = false
  upload_file_pdf(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.Procssing_Import2 = true

    this.DataEntity04_Service.uploadPdf(formData, this.Token).subscribe(
      data => {
        this.Procssing_Import2 = false
        if (data['dsc']) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else {
          this.Alerify_Service.SuccessMessage("The information was loaded successfully.")
          this.FolderName = data['fodlername']

        }
      }
    )

  }

  remove_file_excel(status: number) {
    if (status == 1)
      this.Nominal_Value_List_mg = []
    else if (status == 2)
      this.Nominal_Value_List_g = []
    else
      this.Nominal_Value_List_kg = []
  }

  //#endregion

  //#region Unit

  DataList_Unit: Array<Unit_Interface> = []
  Read_Unit() {
    this.Unit_Service.GetDataEntity(this.Token, this.DataEntity_Id).subscribe(
      data => {
        this.DataList_Unit = data
      },
      (error) => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  //#endregion

  //#region Calibration
  Calibration_Device: Calibration_Interface = Empty_Calibration_Interface();
  Set_CalibrationDeviceInfo_click(input: Calibration_Interface) {
    this.Calibration_Device = input
  }

  //#endregion

  //#region LabAddress

  Set_LabAddress_click(input: string) {
    this.Calibration_Device.labAdderss = input

  }

  //#endregion

  //#region Before

  Add_Before(index: number, status: number) {
    var Temp_Total_Nominal_Value_List: Array<DataEntity_Detail_04_Interface> = [];

    if (status == 1)
      Temp_Total_Nominal_Value_List = this.Nominal_Value_List_mg
    else if (status == 2)
      Temp_Total_Nominal_Value_List = this.Nominal_Value_List_g
    else
      Temp_Total_Nominal_Value_List = this.Nominal_Value_List_kg

    if ((Temp_Total_Nominal_Value_List.length) > index + 1 && Temp_Total_Nominal_Value_List[index + 1].before == true) {
      this.Alerify_Service.ErrorMessage("Copied as the before value.")
    }
    else {

      var Temp_Nominal_Value_List: Array<DataEntity_Detail_04_Interface> = [];

      for (let item of Temp_Total_Nominal_Value_List) {

        if (Temp_Total_Nominal_Value_List.indexOf(item) != index) {
          Temp_Nominal_Value_List.push(item);
        }
        else {
          Temp_Nominal_Value_List.push(item);

          var tempDetail: DataEntity_Detail_04_Interface = Empty_DataEntity_Detail_04_Interface();

          tempDetail.marking = item.marking;
          tempDetail.nominal = item.nominal;
          tempDetail.left = item.found;
          tempDetail.found = "";
          tempDetail.uncertainty = item.uncertainty;
          tempDetail.converage = item.converage;
          tempDetail.uncertainty = item.uncertainty;
          tempDetail.before = true;
          tempDetail.status = status;

          Temp_Nominal_Value_List.push(tempDetail);
        }
      }

      if (status == 1)
        this.Nominal_Value_List_mg = Temp_Nominal_Value_List
      else if (status == 2)
        this.Nominal_Value_List_g = Temp_Nominal_Value_List
      else
        this.Nominal_Value_List_kg = Temp_Nominal_Value_List


    }
  }

  Add_New_Item(status: number) {

    var tempDetail: DataEntity_Detail_04_Interface = Empty_DataEntity_Detail_04_Interface();

    tempDetail.marking = "";;
    tempDetail.nominal = "";;
    tempDetail.left = "";;
    tempDetail.found = "";
    tempDetail.uncertainty = "";;
    tempDetail.converage = "";;
    tempDetail.uncertainty = "";;
    tempDetail.before = false;
    tempDetail.status = status;

    if (status == 1)
      this.Nominal_Value_List_mg.push(tempDetail)
    else if (status == 2)
      this.Nominal_Value_List_g.push(tempDetail)
    else
      this.Nominal_Value_List_kg.push(tempDetail)


  }

  Delete_Before(index: number, status: number) {
    if (status == 1)
      this.Nominal_Value_List_mg.splice(index, 1)
    else if (status == 2)
      this.Nominal_Value_List_g.splice(index, 1)
    else
      this.Nominal_Value_List_kg.splice(index, 1)

    this.Alerify_Service.SuccessMessage("Deleted successfully.")
  }

  //#endregion

  //#region Resolution
  ResolutionFormDataEntity: FormGroup;
  DataList_Resolution: Array<DataEntity_Resolution_04_Interface> = []

  Delete_Resolution(id: number) {
    this.DataList_Resolution.splice(id, 1)
    this.Alerify_Service.SuccessMessage("Deleted successfully.")
  }

  Add_Resolution() {

    var CanAdd: Boolean = true
    for (let item of this.DataList_Resolution) {
      if (Number(item.range_min) <= Number(this.get_Form_range_min().value) && Number(this.get_Form_range_min().value) <= Number(item.range_max) && item.unit == this.get_Form_unit().value) {
        CanAdd = false
        break;
      }
      else if (Number(item.range_min) <= Number(this.get_Form_range_max().value) && Number(this.get_Form_range_max().value) <= Number(item.range_max) && item.unit == this.get_Form_unit().value) {
        CanAdd = false
        break;
      }
    }

    if (this.DataList_Resolution.length >= 7) {
      this.Alerify_Service.ErrorMessage("A maximum of 7 range and resolution entries can be registered.")
    }
    else if (CanAdd) {

      var temp: DataEntity_Resolution_04_Interface = Empty_DataEntity_Resolution_04_Interface()
      temp.range_min = this.get_Form_range_min().value + ''
      temp.range_max = this.get_Form_range_max().value + ''
      temp.unit = this.get_Form_unit().value + ''
      this.DataList_Resolution.push(temp)
      this.Alerify_Service.SuccessMessage("The information was saved successfully.")
    }
    else {
      this.Alerify_Service.ErrorMessage("The new data overlaps existing data.")
    }
  }


  get_Form_range_min() {
    return this.ResolutionFormDataEntity.get('range_min') as FormControl;
  }

  get_Form_range_max() {
    return this.ResolutionFormDataEntity.get('range_max') as FormControl;
  }

  get_Form_unit() {
    return this.ResolutionFormDataEntity.get('unit') as FormControl;
  }

  //#endregion

  modalRef_CodeSerial: any;
  modalRef_Code: any;

  onSubmit(template: TemplateRef<any>, templateCodeSerial: TemplateRef<any>, id: number) {

    if ((this.Calibration_Device.device_serial.trim() == "" || this.Calibration_Device.device_code.trim() == "") && id == 0) {
      this.modalRef_CodeSerial = this.modalService.show(templateCodeSerial);
    }
    else {
      this.InProccessing = true;
      var temp: DataEntity_Main_04_Interface = Empty_DataEntity_Main_04_Interface();

      temp.id = this.Calibration_Id
      temp.filename = this.FileName

      temp.temperature_Air_before = this.get_Form_Temperature_Air_before().value;
      temp.temperature_Air_after = this.get_Form_Temperature_Air_after().value;

      temp.humidity_Air_before = this.get_Form_Humidity_Air_before().value;
      temp.humidity_Air_after = this.get_Form_Humidity_Air_after().value;

      temp.pressure_before = this.get_Form_Pressure_before().value;
      temp.pressure_after = this.get_Form_Pressure_after().value;

      temp.range_nominal = this.range_nominal;
      temp.range_nominal_unit = this.range_nominal_unit;

      temp.capability = this.capability

      this.Nominal_Value_List = []

      for (let item of this.Nominal_Value_List_mg) {
        this.Nominal_Value_List.push(item)
      }
      for (let item of this.Nominal_Value_List_g) {
        this.Nominal_Value_List.push(item)
      }
      for (let item of this.Nominal_Value_List_kg) {
        this.Nominal_Value_List.push(item)
      }

      this.DataEntity04_Service.Submit(
        temp,
        this.Nominal_Value_List,
        this.DataList_Resolution,
        this.DataEntity_Id,
        this.Calibration_Device_Id,
        this.FolderName,
        this.Calibration_Device.device_serial,
        this.Calibration_Device.device_code,
        this.Manufacture_txt,
        this.Type_txt,
        this.Model_txt,
        this.Calibration_Device.labAdderss,
        this.Token
      ).subscribe((data) => {
        this.InProccessing = false;
        if (data['id'] == -1) {
          this.Alerify_Service.ErrorMessage(data['dsc'])
        }
        else if (data['certificate_Code'] == '') {
          this.Alerify_Service.ErrorMessage('System error.');
        } else {
          this.CertificateCode = data['certificate_Code'];
          this.Alerify_Service.SuccessMessage('The information was saved successfully.');

          this.OnIntial()

          if (data['certificateUrl'])
            this.CertificateUrlPdf = environment.BaseUrl + data['certificateUrl']
          else
            this.CertificateUrlPdf = ""

          this.modalRef_Code = this.modalService.show(template);
        }
      });
    }

  }

  onSubmit_Code(template: TemplateRef<any>, templateCodeSerial: TemplateRef<any>, id: number) {
    this.onSubmit(template, templateCodeSerial, 1)
    this.modalRef_CodeSerial.hide()
  }

}
